import { render, staticRenderFns } from "./ConfirmAddress.vue?vue&type=template&id=a6916416&"
import script from "./ConfirmAddress.vue?vue&type=script&lang=ts&"
export * from "./ConfirmAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports